module.exports = __webpack_public_path__ + "img/footer_logo.5c133b67.png";